module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7n9n3r-77f32339f6b8b526b121acc2dca5c829.svg";